import { render, staticRenderFns } from "./CustomTree.vue?vue&type=template&id=70487d04&scoped=true&"
import script from "./CustomTree.vue?vue&type=script&lang=js&"
export * from "./CustomTree.vue?vue&type=script&lang=js&"
import style0 from "./CustomTree.vue?vue&type=style&index=0&id=70487d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70487d04",
  null
  
)

export default component.exports